module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/gift_2-617b30d854bb9ad0900c9aea7b81c53d.png";